import create from 'zustand';
import { getDashboards, shareDashboard } from '../api/dashboards.apis';
import { DashboardStorage } from './types';

const useDashboardStore = create<DashboardStorage>(set => ({
  dashboards: [],
  isLoading: false,
  updateDashboardSharing: async (
    id: string,
    sharedWith: Array<{ id: string }>,
    existingUsers: string[]
  ) => {
    set({ isLoading: true });
    try {
      set(state => {
        return {
          dashboards: state.dashboards.map(d => {
            if (d._id === id) {
              return {
                ...d,
                usersSharedWith: sharedWith
              };
            }
            return d;
          })
        };
      });
      await shareDashboard({
        id,
        usersSharedWith: sharedWith,
        existingUsers
      });
    } catch (e) {
      console.error(e);
    }
    set({ isLoading: false });
  },
  removeDashboard: (id: string) => {
    set(state => {
      return { dashboards: state.dashboards.filter(p => p._id !== id) };
    });
  },
  loadDashboards: async (params) => {
    set({ isLoading: true });
    const list = await getDashboards(params);
    set({ dashboards: list });
    set({ isLoading: false });
  }
}));

export default useDashboardStore;
